import React from "react";
import "./mobile.css";
import "./styles.css";
/**
 * @function PageLayoutContainer
 * @param {React.Component} children - Allows us to inject other containers.
 * @returns {React.Component}
 * @example
 * <PageLayoutContainer>
 *  <LeftColumnContainer/>
 *  <RightColumnContainer/>
 * </PageLayoutContainer>
 */
export default function PageLayoutContainer(props) {
  const className = props.className ?? "";

  return (<div className={ className + " flex-height flex-container flex-horizontal page-layout" }>{props.children}</div>);
}

/**
 * @function LayoutContainer
 * @param {String} className - Allows us to set a class name
 * @param {React.Component} children - Allows us to inject other containers.
 * @returns {React.Component}
 * @example
 * <LayoutContainer>
 *  <LeftColumnContainer/>
 *  <RightColumnContainer/>
 * </LayoutContainer>
 */
export function LayoutContainer(props) {
  const className = props.className ?? "";

  return (<div className={className + " flex-container flex-horizontal flex-width layout-container"}>{props.children}</div>);
}

/**
 * @function LeftColumnContainer
 * @param {React.Component} children - Allows us to inject other containers.
 * @returns {React.Component}
 * @example
 *  <LeftColumnContainer>
 *    <p>This is some text in the left column</p>
 *  </LeftColumnContainer>
 */
export function LeftColumnContainer(props) {
  const dataPoint = props.dataPoint ? { "data-point": props.dataPoint } : {};
  return (<div className="flex-container flex-vertical flex-width left-column" { ...dataPoint }>{props.children}</div>);
}

/**
 * @function RightColumnContainer
 * @param {React.Component} children - Allows us to inject other containers.
 * @returns {React.Component}
 * @example
 *  <RightColumnContainer>
 *    <p>This is some text in the right column</p>
 *  </RightColumnContainer>
 */
export function RightColumnContainer(props) {
  return (<div className="flex-container flex-vertical set-width right-column">{props.children}</div>);
}

/**
 * @function CenterContentContainer
 * @param {React.Component} children - Allows us to inject other containers.
 * @returns {React.Component}
 * @example
 *  <CenterContentContainer>
 *    <p>This is some text in the center column</p>
 *  </CenterContentContainer>
 */
export function CenterContentContainer(props) {
  return (<div className="flex-container flex-vertical flex-width center-content">{props.children}</div>);
}